import { router } from "expo-router";
import { useBoundStore } from "../zustand/Store";
import { Magazine } from "../Datatypes";
import { trackMatomoNotificationEntry } from "@/components/matomo/tracker";

export const useHandleNotificationEntry = () => {
  const updateCurrentMagazine = useBoundStore((state) => state.updateCurrentMagazine);
  const updateCurrentPage = useBoundStore((state) => state.updateCurrentPage);

  return (notificationData: any) => {
    let targetData = notificationData.target; 
    //console.log("useHandleNotificationEntry - notificationData: ", notificationData)
    
    if (notificationData.type === "ArticleLink" && notificationData.target) {
      trackMatomoNotificationEntry('Push-Benachrichtigung', 'Artikel', targetData, 'userType');
      router.push({
        pathname: '/',
        params: { webViewURL: notificationData.target },
      });

    } else if (notificationData?.type === "EpaperLink" && notificationData.target) {
      
      let targetData = typeof notificationData.target === "string"
        ? JSON.parse(notificationData.target)
        : notificationData.target

      trackMatomoNotificationEntry('Push-Benachrichtigung', 'Epaper', `${targetData.date}_${targetData.edition}`, 'userType');


      const magazine: Magazine = {
        date: targetData.date as string,
        edition: targetData.edition as string,
      };
      //console.log(magazine)
      updateCurrentMagazine(magazine);
      updateCurrentPage(1);
      router.push({
        pathname: '/PDFViewer',
      });
    } else {
      console.warn("Unhandled notification type or missing target:", notificationData);
    }
  }
}